import * as Types from 'graphql-api/gql-api-interfaces';

// REVIEW not sure where to keep this
// In various apis (merchandise, content, story) we are using this structure through console
// But the idea is to map this structure into our gql variables
// Better solution would be to change how console is storing links, so no mapping would be required
export interface IConsoleSearchParams {
  structure?: string[];
  query?: string;
  preset?: string | null;
  facets?: {
    [key: string]: string;
  };
  sort?: {
    field: Types.SearchSortType;
    direction?: Types.SortingDirection;
  };
  orderType?: Types.OrderType;
  availability?: string;
  availabilities?: string[];
  wspdp?: boolean;
  maxAge?: number;
  subSite?: string;
}
export function capitalizeFirstLetter(value: string) {
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}
export function capitalizeOnlyFirstLetter(value: string) {
  return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
}

// TODO use return type Types.SearchQuery | null
// once it's all mapped properly
export function mapInternalLinkParams(params: IConsoleSearchParams): {
  [key: string]: string;
} | null {
  if (!params) return null;

  const { facets, sort, query, structure, availabilities, ...rest } = params;
  const result = {
    q: query ?? '',
    f: getFacets(facets),
    sortField: sort?.field
      ? capitalizeFirstLetter(sort.field)
      : Types.SearchSortType.Default,
    sortDirection: sort?.direction
      ? capitalizeOnlyFirstLetter(sort.direction)
      : Types.SortingDirection.Asc,
    structure: joinStringArr(structure),
    availability: joinStringArr(availabilities),
    ...rest,
  };

  return Object.keys(result)
    .map((key: keyof typeof result) => ({ key, value: result[key] }))
    .filter(({ value }) => !!value)
    .reduce((prev, { key, value }) => ({ ...prev, [key]: value }), {});
}

function getFacets(facets: IConsoleSearchParams['facets']): string {
  if (!facets) return '';
  const result: string[] = [];
  Object.keys(facets).forEach((key) => {
    const value = facets[key];
    result.push(`${key}:${value}`);
  });
  return result.join(',');
}

function joinStringArr(values?: string[]) {
  return (values?.length ?? 0) > 0 ? values?.join(',') : null;
}
